import ___svg_imagealttextSvg from '../svg/imagealttext.svg';
import { altTextTitle } from './imageAltText.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';
import getSelectedImage from 'owa-editor/lib/utils/getSelectedImage';
import { callFormatApi } from 'owa-editor/lib/utils/callFormatApi';
import { lazyShowImageAltTextDialog } from 'owa-editor-ribbon-secondary-ui';

const imageAltText: RibbonButton = {
    key: 'imageAltText',
    title: () => loc(altTextTitle),
    imageSrc: ___svg_imagealttextSvg,
    buttonState: formatState =>
        formatState.canAddImageAltText ? RibbonButtonState.Normal : RibbonButtonState.Disabled,
    onExecute: (editorViewState, formatState, targetWindow) => {
        const nodeSelectedByPlugin = getSelectedImage(editorViewState);
        const node = getSelectedImage(editorViewState, true /*includeEditorSelection*/);

        lazyShowImageAltTextDialog.import().then(showImageAltTextDialog =>
            showImageAltTextDialog(node, targetWindow, alt => {
                if (nodeSelectedByPlugin) {
                    nodeSelectedByPlugin.alt = alt;
                } else {
                    callFormatApi(
                        editorViewState,
                        'setImageAltText',
                        [alt],
                        [] /* pass empty array to avoid logging */
                    );
                }
            })
        );
    },
};

export default imageAltText;
